<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <div class="pb-4">
          <contact-faq />
        </div>
        <div>
          <h1 class="text-title-underline">{{ t('contact.title') }}</h1>
          <base-alert class="mt-2 mb-4" />
          <template v-if="!store.state.contact.contactConfirm.on">
            <contact-form />
          </template>
          <template v-if="store.state.contact.contactConfirm.on">
            <contact-confirm />
          </template>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store/index'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import ContactForm from '@/components/ContactForm.vue'
import ContactConfirm from '@/components/ContactConfirm.vue'
import ContactFaq from '@/components/ContactFaq.vue'

export default defineComponent({
  components: { LayoutsAuth, BaseAlert, LayoutsAuthWidth, ContactForm, ContactConfirm, ContactFaq },
  setup() {
    const { t } = useI18n()
    const store = useStore()

    onMounted(() => {
      Promise.allSettled([
        store.dispatch('contact/fetchCategory'),
        store.dispatch('contact/fetchCourse'),
        store.dispatch('contact/fetchFaqCategories')
      ])
    })

    return {
      t,
      store,
    }
  },
})
</script>
